// Package Imports
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'
import { toAdminListParams } from '@/core/lib/table-query'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Module Imports
import {
  avatarDetailQueryOptions,
  avatarListQueryOptions,
} from '@/modules/avatar/avatar.hooks'
import { avatarSearchSchema } from '@/modules/avatar/avatar.schemas'

export const avatarRoute = createRoute({
  path: '/avatars',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const avatarListRoute = createRoute({
  getParentRoute: () => avatarRoute,
  path: '/',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'avatars.list',
      'Avatar listesine erişim izniniz yok.'
    )
  },
  head: () => ({
    meta: [
      {
        title: 'Avatar Listesi',
      },
    ],
  }),
  validateSearch: avatarSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ deps }) => {
    await queryClient.ensureQueryData(
      avatarListQueryOptions(toAdminListParams(deps))
    )
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/avatar/pages/list-avatar.page')
  ),
})

export const avatarCreateRoute = createRoute({
  getParentRoute: () => avatarRoute,
  path: '/create',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'avatars.create',
      'Avatar oluşturmak için yetkiniz yok.'
    )
  },
  head: () => ({
    meta: [{ title: 'Avatar Oluştur' }],
  }),
  component: lazyRouteComponent(
    () => import('@/modules/avatar/pages/create-avatar.page')
  ),
})

export const avatarEditRoute = createRoute({
  getParentRoute: () => avatarRoute,
  path: '/$id/edit',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'avatars.edit',
      'Avatar düzenlemek için yetkiniz yok.'
    )
  },
  head: async ({ params: { id } }) => {
    const avatar = await queryClient.fetchQuery(avatarDetailQueryOptions(id))

    return {
      meta: [
        {
          title: `Avatar Düzenle ${avatar.name}`,
        },
      ],
    }
  },
  component: lazyRouteComponent(
    () => import('@/modules/avatar/pages/edit-avatar.page')
  ),
})
